import { WebStore } from "@i.un/libs";

// 定义不同类型的数据结构
type AppBridgeData = {
  ExtensionInfo: {
    locale: string;
    extId: string;
    version: string;
  };
  CookieParams: {
    cookie: string;
    csrfToken: string;
  };
};

// 用户登录后可用的数据
type UserLocalData = {
  //   ResharePostTimes: number; // 转发post次数
  SubscripVersionChooseName: string; // 选择名称
  SubscripChangeType: string; // 升降级类型 1升级 -1降级
  SubscripPlanLabel: string; // 升降级后的套餐标签
};

type TLocalStore = {
  app_bridge_data: AppBridgeData;
  user_local_data: UserLocalData;
};

function getStore<T extends keyof TLocalStore>(key: T) {
  return WebStore.local<TLocalStore[T]>(key);
}

export function getAppBridgeStore() {
  return getStore("app_bridge_data");
}

export function getUserLocalStore() {
  return getStore("user_local_data");
}

// 创建特定类型的存储实例
// AppBridgeStore 在web下读，在插件中写
// export const AppBridgeStore = getStore("app_bridge_data");
// export const UserLocalStore = getStore("user_local_data");
